import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Recent from './components/Recent';
import Popular from './components/Popular';
import Home from './components/Home';
import TopNav from './components/TopNav';
import MovieDetails from './components/MovieDetails';
import SearchBar from './components/SearchBar'; // Make sure to create this component
import HomeCard from './components/HomeCard';

const App = () => {
  return (
    <Router>
            <TopNav />
      <Routes>
      <Route path="/" element={<Home />} />
        <Route path="/recent" element={<Recent />} />
        <Route path="/popular" element={<Popular />} />
        <Route path="/movies/:id" element={<MovieDetails />} />
        <Route path="/search/:query" element={<SearchBar />} />
        {/* Other routes */}
      </Routes>
      <HomeCard />
    </Router>
  );
};

export default App;
